import React from 'react';
import styled from 'styled-components';
import { parseISO, format } from 'date-fns/fp';
import { variant } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import { Card } from './Card';
import { CardInfo } from '../cardInfo/CardInfo';
import { CARD_VARIANT } from './constants';
import { getHeaderVariant } from './utils/responsiveProps';
import { Tag } from '../tag/Tag';
import { Link } from '../link/Link';

const eventCardDateStyle = variant({
  key: 'card.event.date',
});

const Date = styled.span`
  ${eventCardDateStyle}
  font-size: ${themeGet('card.event.date.fontSize')};
  font-weight: ${themeGet('card.event.date.fontWeight')};
`;

const Head = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const EventCard = ({
  variant,
  status,
  coverUrl,
  date,
  dateFormat,
  title,
  description,
  tags,
  links,
  cardInfoData,
  ...rest
}) => {
  const headerVariant = getHeaderVariant(variant, coverUrl);

  const header = date && (
    <Head>
      <Date variant={headerVariant}>{format(dateFormat, parseISO(date))}</Date>
      {status}
    </Head>
  );

  return (
    <Card
      variant={variant}
      coverUrl={coverUrl}
      header={header}
      footer={cardInfoData && <CardInfo data={cardInfoData} />}
      {...rest}
    >
      <Card.Meta title={title} description={description}>
        {tags && <Tag.Group maxCounts={2}>{tags}</Tag.Group>}
        {links && <Link.Group maxCounts={2}>{links}</Link.Group>}
      </Card.Meta>
    </Card>
  );
};

EventCard.defaultProps = {
  variant: CARD_VARIANT.VERTICAL,
  dateFormat: 'yyyy-MM-dd',
};
